import { render } from "./EmailAlert.vue?vue&type=template&id=892bbcf6"
import script from "./EmailAlert.vue?vue&type=script&lang=js"
export * from "./EmailAlert.vue?vue&type=script&lang=js"

import "./EmailAlert.vue?vue&type=style&index=0&id=892bbcf6&lang=scss"

import exportComponent from "/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.1.6__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__